import actions from '../utils/restActions';
import { customRequest} from '../utils/restUtils';

export const contactAction = (contact) => {
    return (dispatch) => {
	return customRequest(actions.contact.create, contact).then((res) => {
	    return dispatch({ type: actions.contact.create.status.success, data: res});
	})
    }
}




// WEBPACK FOOTER //
// ./src/actions/Contact.js